export const EnvVars = {
    SITE_NAME: 'Меню на Братчина',
    MAIN_BTN_LINK: '#',
    API: 'https://admin.bratchina.com/api/',
    SOURCE: 'https://admin.bratchina.com/storage/'
    // API: 'http://127.0.0.1:8000/api/',
    // SOURCE: 'http://127.0.0.1:8000/storage/'
};